module.exports = __webpack_public_path__ + "img/edit.e379e6ab.svg";